var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClose = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8001 8.56804L16.6359 13.7323L11.4717 8.56804C10.6954 7.79172 9.48025 7.79172 8.70393 8.56804C7.92761 9.34436 7.92761 10.5595 8.70393 11.3358L13.8681 16.5L8.70393 21.6642C7.92761 22.4405 7.92761 23.6556 8.70393 24.432C9.48025 25.2083 10.6954 25.2083 11.4717 24.432L16.6359 19.2677L21.8001 24.432C22.5764 25.2083 23.7915 25.2083 24.5679 24.432C25.3442 23.6556 25.3442 22.4405 24.5679 21.6642L19.4036 16.5L24.5679 11.3358C25.3442 10.5595 25.3442 9.34436 24.5679 8.56804C23.7915 7.79172 22.5764 7.79172 21.8001 8.56804Z",
    fill: "#37C2D7"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close.b4b16a1cec8828255814eb9e1fef5f2b.svg";